(() => {
  'use strict';
  const dialog=document.querySelector('[data-qcontact-dialog]');
  if(!dialog)return;
  const form=dialog.querySelector('.qcontact-form');
  if(form){
    const fields=Array.from(form.querySelectorAll('input:not([type="hidden"]),textarea'));
    const summary=form.querySelector('[data-qcontact-validation-summary]');
    const message=form.querySelector('#qcontact-message');
    const counter=form.querySelector('[data-qcontact-count]');
    const numberFormat=new Intl.NumberFormat(document.documentElement.lang||'pt-PT');
    function updateCount(){
      if(counter&&message)counter.textContent=numberFormat.format(message.value.length)+' / '+numberFormat.format(message.maxLength);
    }
    function validateField(field){
      const error=field.closest('label')?.querySelector('[data-qcontact-field-error]');
      let text='';
      if(field.required&&!field.value.trim())text=field.dataset.requiredMessage;
      else if(field.validity.typeMismatch)text=field.dataset.invalidMessage;
      else if(field.maxLength>0&&field.value.length>field.maxLength)text=field.dataset.invalidMessage||field.dataset.requiredMessage;
      if(error){error.textContent=text||'';error.hidden=!text;}
      if(text)field.setAttribute('aria-invalid','true');
      else field.removeAttribute('aria-invalid');
      return !text;
    }
    fields.forEach(field=>field.addEventListener('input',()=>{
      if(field.hasAttribute('aria-invalid'))validateField(field);
      if(summary&&!fields.some(input=>input.hasAttribute('aria-invalid')))summary.hidden=true;
      updateCount();
    }));
    form.addEventListener('submit',event=>{
      const invalid=fields.filter(field=>!validateField(field));
      if(summary)summary.hidden=!invalid.length;
      if(invalid.length){
        event.preventDefault();event.stopImmediatePropagation();invalid[0].focus();
      }
    },true);
    form.noValidate=true;
    updateCount();
  }
  let previousFocus=null,previousOverflow='';
  function openContact(opener){
    if(dialog.open)return;
    previousFocus=opener||document.activeElement;
    previousOverflow=document.body.style.overflow;
    dialog.showModal();document.body.style.overflow='hidden';
  }
  document.querySelectorAll('[data-qcontact-open]').forEach(button=>button.addEventListener('click',()=>openContact(button)));
  dialog.querySelector('[data-qcontact-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click',event=>{
    if(event.target!==dialog)return;
    const bounds=dialog.getBoundingClientRect();
    if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
  });
  dialog.addEventListener('close',()=>{
    document.body.style.overflow=previousOverflow;
    if(previousFocus?.isConnected)previousFocus.focus({preventScroll:true});
  });
  window.addEventListener('hashchange',()=>{if(location.hash==='#qroses-contact-dialog')openContact();});
  if(dialog.querySelector('[data-contact-success],[data-contact-errors]')||location.hash==='#qroses-contact-dialog')openContact();
})();
